import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon, ShieldCheckIcon, XCircleIcon, CheckCircle2Icon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <>
      <section className="pt-20 pb-10 md:pt-24 md:pb-14 px-4 overflow-hidden relative" data-id="element-121">
        {/* Decorative background blur */}
        <div className="absolute top-20 left-10 w-72 h-72 bg-brand-green/10 rounded-full blur-3xl -z-10" data-id="element-122" />

        <div className="max-w-3xl mx-auto" data-id="element-123">
          <div className="flex flex-col items-center text-center" data-id="element-124">
            {/* Single Column: Copy */}
            <motion.div className="w-full" initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-125">
              <div className="flex flex-wrap justify-center gap-3 mb-5" data-id="element-126">
                <span className="inline-flex items-center text-xs font-black tracking-widest uppercase bg-brand-gold/20 text-brand-brown px-4 py-1.5 rounded-full border border-brand-gold/30 shadow-sm" data-id="element-127">
                  Oferta de Lanzamiento
                </span>
                <span className="inline-flex items-center text-xs font-black tracking-widest uppercase bg-brand-green/15 text-brand-dark-green px-4 py-1.5 rounded-full border border-brand-green/30 shadow-sm" data-id="element-128">
                  Garantía 30 Días
                </span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-[1.08] mb-5 tracking-tight" data-id="element-129">
                Hacé tu Primer Jabón Artesanal{' '}
                <br className="hidden md:block" data-id="element-130" />
                <span className="text-brand-green italic font-playfair relative inline-block mt-1" data-id="element-131">
                  en las Próximas 24 Horas
                  <svg className="absolute w-full h-3 -bottom-1 left-0 text-brand-gold/40" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-132">
                    <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="transparent" data-id="element-133" />
                  </svg>
                </span>
              </h1>

              <p className="text-lg md:text-xl text-brand-brown/80 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-134">
                El sistema paso a paso más completo para que empieces a{' '}
                <strong className="text-brand-brown font-black bg-brand-gold/30 px-1.5 py-0.5 rounded-sm" data-id="element-135">
                  crear y vender jabones artesanales desde casa
                </strong>{' '}
                —{' '}
                <span className="underline decoration-brand-green/50 decoration-2 underline-offset-4 font-bold text-brand-dark-green" data-id="element-136">
                  aunque nunca hayas hecho uno antes.
                </span>
              </p>

              <div className="mb-5 bg-white/60 p-4 rounded-2xl border border-brand-brown/5 inline-block shadow-sm" data-id="element-137">
                <div className="text-sm text-brand-brown/60 uppercase tracking-widest mb-1 font-bold" data-id="element-138">
                  Precio Especial Hoy
                </div>
                <div className="flex items-center justify-center gap-4" data-id="element-139">
                  <PriceDisplay amount="7.990" originalAmount="39.990" fixedSymbol="$" className="text-4xl md:text-5xl text-brand-dark-green font-black tracking-tight" data-id="element-140" />
                </div>
              </div>

              <CTAButton className="mb-5 w-full md:w-[80%] text-xl py-5 shadow-[0_10px_30px_rgba(45,90,61,0.4)]" data-id="element-141">
                QUIERO MIS 6 TOMOS AHORA →
              </CTAButton>

              <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm md:text-base font-bold text-brand-brown/80 mb-8" data-id="element-142">
                <span className="flex items-center justify-center gap-2" data-id="element-143">
                  <CheckIcon className="w-5 h-5 text-brand-green stroke-[3]" data-id="element-144" />{' '}
                  Pago único
                </span>
                <span className="flex items-center justify-center gap-2" data-id="element-145">
                  <CheckIcon className="w-5 h-5 text-brand-green stroke-[3]" data-id="element-146" />{' '}
                  Acceso inmediato
                </span>
                <span className="flex items-center justify-center gap-2" data-id="element-147">
                  <CheckIcon className="w-5 h-5 text-brand-green stroke-[3]" data-id="element-148" />{' '}
                  Garantía 30 días
                </span>
              </div>

              <motion.img src="https://cdn.magicpatterns.com/uploads/iHCRyENSLFSg8Y73V3FUbN/20260301_1102_Image_Generation_simple_compose_01kjmv9h15fcnbzcrd9yqp7p8r.png" alt="Sabé exactamente lo que estás usando - Aprendé a crear tus propios jabones naturales" className="w-full max-w-lg mx-auto rounded-2xl shadow-lg" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} data-id="element-149" />
            </motion.div>
          </div>
        </div>
      </section>
    </>;
}
const painPoints = [{
  title: 'Querés emprender pero no sabés por dónde empezar',
  desc: 'y cada vez que buscas información terminás <strong class="text-pain-red">más confundida que antes.</strong>'
}, {
  title: 'Ya intentaste aprender en YouTube',
  desc: 'y los lotes te salieron mal porque los videos <strong class="text-pain-red">saltan los pasos clave.</strong>'
}, {
  title: 'Creés que emprender es muy caro',
  desc: 'y gastaste plata en <strong class="text-pain-red">materiales equivocados sin resultados.</strong>'
}, {
  title: 'Hacés productos lindos pero no sabés cómo venderlos',
  desc: 'y terminás <strong class="text-pain-red">regalándolos o acumulando stock.</strong>'
}, {
  title: 'Probaste cursos caros que no cumplieron lo prometido',
  desc: 'y perdiste confianza en <strong class="text-pain-red">volver a invertir.</strong>'
}];
export function PainPointsSection() {
  return <>
      <section className="py-24 px-4 bg-white relative" data-id="element-150">
        <div className="max-w-3xl mx-auto" data-id="element-151">
          <div className="text-center mb-16" data-id="element-152">
            <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-153">
              ¿Esto es para vos?
            </h2>
            <p className="text-xl md:text-2xl text-brand-brown/80 font-medium leading-relaxed" data-id="element-154">
              Este sistema es para vos si…
              <br data-id="element-155" />
              <span className="text-brand-brown font-bold mt-2 block" data-id="element-156">
                Reconocé tu situación en al menos uno de estos puntos:
              </span>
            </p>
          </div>

          <div className="space-y-5 mb-16" data-id="element-157">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-5 bg-red-50/40 p-6 md:p-8 rounded-2xl border border-red-100/50 hover:bg-red-50/80 transition-colors duration-300" data-id="element-158">
                <XCircleIcon className="w-8 h-8 text-pain-red shrink-0 mt-1 stroke-[2.5]" data-id="element-159" />
                <div data-id="element-160">
                  <h3 className="font-bold text-brand-brown text-xl md:text-2xl mb-2 leading-tight" data-id="element-161">
                    {point.title}
                  </h3>
                  <p className="text-brand-brown/80 text-lg md:text-xl leading-relaxed" dangerouslySetInnerHTML={{
                __html: point.desc
              }} data-id="element-162" />
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex flex-col md:flex-row items-center md:items-start gap-6 bg-gradient-to-br from-green-50 to-green-100/50 p-8 md:p-10 rounded-3xl border-2 border-solution-green/20 shadow-lg relative overflow-hidden" data-id="element-163">
            <div className="absolute -right-10 -top-10 text-solution-green/5 text-9xl" data-id="element-164">
              ✓
            </div>
            <CheckCircle2Icon className="w-12 h-12 text-solution-green shrink-0 relative z-10" data-id="element-165" />
            <p className="text-xl md:text-2xl font-medium text-brand-dark-green leading-relaxed text-center md:text-left relative z-10" data-id="element-166">
              Si te identificaste con alguno de estos puntos, el{' '}
              <strong className="font-black text-highlight px-1" data-id="element-167">
                Mega Pack Jabones Artesanales
              </strong>{' '}
              fue diseñado exactamente para vos.
            </p>
          </motion.div>

          <div className="mt-20 text-center max-w-2xl mx-auto" data-id="element-168">
            <p className="text-xl md:text-2xl text-brand-brown/80 leading-relaxed font-medium" data-id="element-169">
              Si querés crear jabones artesanales de forma rápida y{' '}
              <strong className="font-bold text-brand-brown" data-id="element-170">
                sin desperdiciar dinero
              </strong>{' '}
              en materiales equivocados o cursos que no explican nada,{' '}
              <mark data-id="element-171">esta es la herramienta definitiva.</mark>
            </p>
          </div>
        </div>
      </section>
    </>;
}